import { APITransport } from '@client/transports/api';

export const TagBlocksService = {
  clone(body = {}) {
    return APITransport.post({
      path: '/rest/user/execute/clonetagblock',
      body
    });
  },

  create(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/tagblocks',
      body: {
        replyhtmltemplate: '',
        replytemplateenabled: false,
        replytexttemplate: '',
        sigblock: true,
        sigcode: '+',
        status: true,
        texttemplate: '{{ name }}\n{{ title }}',
        _newObject: true,
        ...body
      }
    });
  },
  delete(body = {}) {
    return APITransport.post({
      path: '/rest/domain/delete/tagblocks',
      body
    });
  },
  async getAll(query = {}) {
    const response = await APITransport.get({
      path: '/rest/domain/tagblocks',
      query
    });

    return Array.isArray(response) ? response : [];
  },
  getWarnings(item, params = {}, data = {}) {
    return APITransport.post({
      path: `/rest/domain/tagblocks/${item._id}/warnings`,
      body: {
        params,
        data
      }
    });
  },
  async getById(id) {
    const tags = await TagBlocksService.getAll();
    return tags.find(({ rulename }) => rulename === id);
  },
  save(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/tagblocks',
      body
    });
  }
};
